<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Section Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-md-9">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Section Name</mat-label>
          <input
            matInput
            placeholder="Section Name"
            [(ngModel)]="section.name"
            name="name"
            type="text"
            #name
            required />
          <mat-error *ngIf="!name.valid">Please enter a section name.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select
            placeholder="Status"
            [(ngModel)]="section.status"
            name="status"
            required
            matTooltip="Draft sections will not be visible to {{ utils.getLangTerm('contractors.plural', 'Contractors') }} and {{ utils.getLangTerm('employees.plural', 'Employees') }}." >
            <mat-option value="Draft">Draft</mat-option>
            <mat-option value="Published">Published</mat-option>
          </mat-select>
          <mat-error *ngIf="!section.status">Please select the status of this section.</mat-error>
        </mat-form-field>
      </div>
    </div>

    <app-rich-text-editor
      placeholder="Section Content *"
      [(ngModel)]="section.content"
      name="content"
      [height]="300">
    </app-rich-text-editor>
    <mat-error *ngIf="!section.content">Please select the content of this section.</mat-error>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      type="submit"
      mat-raised-button
      [disabled]="!f.valid || inProgress || !section.content"
      color="primary"
      class="my-2 ml-1 mr-2">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      *ngIf="canDelete"
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!section.id"
      class="dialog-remove-button m-1 ml-auto"
      (click)="onRemove()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>

</form>
